<template>
  <div class="container contacto" :data-testid="TEST_ID.CONTACT.ROOT">
    <div class="title" :data-testid="TEST_ID.CONTACT.TITLE">{{ $t('CONTACTO_contacto') }}</div>
    <div class="card_container">
      <el-card>
        <div class="form">
          <el-row :gutter="20">
              <el-col :span="24">
                <div class="label" style="font-weight:bold !important; margin-bottom:15px !important;">{{$t('CONTACTO_a_su_disposicion')}}</div>
              </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="label first">{{ $t('CONTACTO_enviar') }}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="seleccion">
                <div style="width: 250px;">
                  <el-select v-model="indexContacto" :placeholder="$t('GENERAL_seleccione')" @change="mostrarDatosContacto">
                <el-option v-for="(contacto, index) in listaContactos" :key="index" :value="index" :label="contacto.Nombre"></el-option>
              </el-select>
                </div>
              
              <div v-if="showDatosContacto" class="tarjetaContacto">
                <span>Email: {{email}}</span>
                <span>Telefono: {{telefono}}</span>
              </div>
              </div>
            </el-col>
            <el-col :span="6" col-xs-3 col-md-3 col-lg-3 pull-left allign="center">
              <a v-if="indexContacto!=undefined" :href="whatsappLink" method="get" target="_blank" class="whatsapp-desktop">
              <img height="40" width="40" src="@/images/whats-logo.png" alt="Contactanos por Whatsapp">
              </a>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="24">
              <div class="label">{{ $t('CONTACTO_mensaje') }}</div>
              <editor-content class="textarea" :editor="editor" />
            </el-col>
          </el-row>
        </div>
      <el-button 
        class="btn" 
        type="primary" 
        :loading="enviando"
        @click="onEnviar">
        {{ $t('GENERAL_enviar') }}
      </el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { useEditor, EditorContent } from '@tiptap/vue-3'
  import StarterKit from '@tiptap/starter-kit'
  import { mapState } from 'vuex'
  import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado/index'
  import { showError, showSuccess } from '../Mensaje'
  import TEST_ID from '@/testIds.json'
  const emailCuentaPrincipal = 'creditosycob@colven.com.ar';
  const emailCuentaGestion = 'cobranzas@gestya.com';
  export default {
    name: "ContactoForm",
    components: { EditorContent },
    setup() {
      const editor = useEditor({
        extensions: [StarterKit],
        content: '<p></p>',
      })

      return {
        editor
      }
    },
    data() {
      return {
        TEST_ID,
        indexContacto: undefined,
        enviando: false,
        navegandoDesdeCuentas: false,
        cuenta: undefined,
        email: undefined,
        telefono: undefined,
        showDatosContacto: false
      }
    },
    computed: {
      ...mapState({
        listaContactos: state => state.contacto.listaContactos,
        sesion: state => state.sesion.resultadoAutenticacion,
      }),
      whatsappLink: function () {
        var cont = this.listaContactos[this.indexContacto]
        return "https://web.whatsapp.com/send?phone="+cont.Telefono+"&amp;text[body]=Hola,%20tengo%20una%20consulta%20desde%20ColvenNet"
      }
    },
    methods: {
      mostrarDatosContacto() {
        this.showDatosContacto = true
        this.email = this.listaContactos[this.indexContacto].Email
        this.telefono = this.listaContactos[this.indexContacto].Telefono
      },
      onEnviar() {
        // indico que se está enviando el mail
        this.enviando = true

        let valida = true
        let errorMsg = ''

        // validaciones
        if(this.editor?.isEmpty)
        {
          errorMsg = this.$t('CONTACTO_missing_mensaje')
          valida = false
        }

        if(this.indexContacto === undefined || this.listaContactos[this.indexContacto] === undefined) {
          errorMsg = this.$t('CONTACTO_missing_enviar')
          valida = false
        }

        // si no valida muestro el mensaje de error y retorno
        if(!valida)
        {
          showError(errorMsg)
          this.enviando = false
          return
        }
        // armo el payload
        let payload = {
          idUsuario: this.sesion.IdUsuario,
          nombreUsuario: this.sesion.NombreCompleto,
          email: this.listaContactos[this.indexContacto].Email,
          mensaje: this.editor?.getHTML() ?? ''
        }        
        if(this.cuenta === "Principal")
          payload.email = emailCuentaPrincipal;
        else if(this.cuenta === "Gestion GPRS")
          payload.email = emailCuentaGestion;

        // envío el mensaje
        this.$store.dispatch('contacto/enviarMensaje', payload)
        .then(data => {
          
          // éxito
          if(data === 0)
            showSuccess(this.$t('CONTACTO_success'))

          // error
          else
            mostrarMensajeInternacionalizado(data)
        })
        .finally(() => { 
          this.enviando = false 
          this.$router.push({ name: 'Main' })
        })
      }
    },
    mounted() {
      this.$store.dispatch('contacto/getListaContactos').then(() => {
        if(this.$route.params.cuenta)
        {
          this.cuenta = this.$route.params.cuenta
          this.indexContacto = this.listaContactos.findIndex(x => x.Nombre === "Créditos y Cobranzas");
        }
      })
    }
  }

</script>

<style scoped>
.seleccion{
  display: flex;
  width: 100%;
  max-width: 700px;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  }
  .tarjetaContacto{
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 30px;
  max-width: 400px;
  width: 100%;
}
  .whatsapp-desktop{
    padding: 10px;
    margin-left: 55px;
  }
  .container {
    padding: 20px 40px;
    box-sizing: border-box;
  }
  .title {
    font-size: 22px;
    font-weight: bold;
    text-align: left;
    color: var(--main-color);
    margin-bottom: 20px;
  }
  .card_container {
    max-width: 800px;
  }
  .form {
    text-align: left;
    padding: 5px 20px;
  }
  .label {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .label.first {
    margin-top: 0px;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
    display: inline-block;
  }
  .textarea {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 5px 15px;
  }

  @media(max-width: 800px) {

    .form {
      padding: 10px;
    }

  }

  @media (max-width: 800px) {
    .seleccion {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .tarjetaContacto {
      margin-left: 0;
      width: 100%;
    }

    .whatsapp-desktop {
      margin-left: 0;
    }
  }

</style>

<style>
  .ProseMirror {
    padding: 0px;
    margin-top: 0px;
    outline: none;
  }
  .contacto p {
    margin: 0px;
    font-size: 14px;
    color: #606266;
    min-height: 100px;
  }
</style>